import React from 'react';
import PropTypes from 'prop-types';
import { Shimmer, ShimmerWrapper } from './LoadingShimmerStyledComponents';
export default function LoadingShimmer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      animationDuration = _ref.animationDuration;
  return React.createElement(ShimmerWrapper, {
    animationDuration: animationDuration
  }, React.createElement(Shimmer, {
    width: width,
    height: height
  }));
}
LoadingShimmer.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  animationDuration: PropTypes.number
};
LoadingShimmer.defaultProps = {
  width: 164,
  height: 16,
  animationDuration: 6
};